/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Button, Segment } from 'semantic-ui-react';
import { FormControlLabel, Checkbox } from '@mui/material';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import '../App.css';
import { useDispatch, useSelector } from 'react-redux';
import { changeBrowserTabTitle } from '../slices/browserTabTitle/browserTabTitleSlice';
import { useNavigate } from 'react-router-dom';
import { selectCurrentUserIdToken, selectDisplayTheTermsOfAgreement } from '../slices/currentUser/currentUserSlice';
import server_config from '../ServerConfiguration';
import axios from 'axios';

const fevir_go_server_address = server_config["fevir_go_server_address"];

const agreedToTermsAction = async (idToken, navigate) => {

    if (idToken) {
        const body = {
            'functionid': "login",
            'idToken': idToken,
            'agreetoterms': true
        };
        await axios({
            method: 'POST',
            //url: server_address + ':' + ports["master_server"] + '/',
            url: fevir_go_server_address,
            timeout: 8000,
            data: body,
        }).then((resp) => {
            if (resp?.data?.success) {
                navigate("/"); //TODO consider which target is desired here and the else
                //TODO - redirect to the original URL or previous page
            } else {
                navigate(0);
            }
        })
    }
}

const TermsOfAgreementPage = ({ waitingForVerificationEmail }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const idToken = useSelector(selectCurrentUserIdToken);
    const displayTheTermsOfAgreement = useSelector(selectDisplayTheTermsOfAgreement);

    const [agreementState, setAgreementState] = useState({
        termsofuseacceptCheckbox: false,
        datapersonalagreementacceptCheckbox: false
    });

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR Terms of Agreement"));
    }, []);

    useEffect(() => {
        if (!displayTheTermsOfAgreement) {
            navigate("/editprofile");
        }
    }, [displayTheTermsOfAgreement]);

    return <div>
        <br />
        <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
            {(firebase.auth().currentUser?.emailVerified === false || waitingForVerificationEmail) ?
                <h2>Please verify your email. Check your spam folder. (If you already did verify please refresh the page.)</h2>
                :
                <div>
                    <h2 style={{ textAlign: "center", color: "#AC3B61" }}>Terms of Agreement</h2>
                    <Button style={{ position: "absolute", right: "3px", top: "3px" }}
                        className="formButton negative" content="✖"
                        onClick={() => { navigate("/"); }} />
                    <br /><br />
                    <FormControlLabel
                        control={<Checkbox style={{ pointerEvents: "auto" }} name="termsofuseaccept"
                            inputProps={{ 'aria-label': 'Agree to the Terms of Use' }} color="primary"
                            checked={agreementState.termsofuseacceptCheckbox}
                            onChange={(e) => {
                                setAgreementState(prevState => {
                                    return { ...prevState, "termsofuseacceptCheckbox": e.target.checked };
                                });
                            }} />}
                        label={<span>I agree to the <a href="/termsofuse" target="_blank"
                            rel="noopener noreferrer"
                            style={{ pointerEvents: "auto" }}>Acceptable Use Policy</a></span>}
                    />
                    <br />
                    <FormControlLabel
                        style={{ pointerEvents: "none" }}
                        control={<Checkbox style={{ pointerEvents: "auto" }} name="datapersonalagreementaccept"
                            inputProps={{ 'aria-label': 'Agree to the Personal Data Agreement Terms' }}
                            color="primary" checked={agreementState.datapersonalagreementacceptCheckbox}
                            onChange={(e) => {
                                setAgreementState(prevState => {
                                    return { ...prevState, "datapersonalagreementacceptCheckbox": e.target.checked };
                                });
                            }} />}
                        label={<span>I agree to the <a href="/personaldataagreement" target="_blank"
                            rel="noopener noreferrer"
                            style={{ pointerEvents: "auto" }}>Privacy Policy Agreement</a></span>}
                    />
                    <br /><br />
                    {idToken &&
                        <Button className="formButton positive"
                            content="Agree to the Terms" compact
                            onClick={() => { agreedToTermsAction(idToken, navigate); }}
                            disabled={!(agreementState.termsofuseacceptCheckbox &&
                                agreementState.datapersonalagreementacceptCheckbox)} />
                    }
                </div>
            }
        </Segment>
        <br /><br /><br /><br />
    </div>;
};

export default TermsOfAgreementPage;